import {HomePage} from './pages/home_page'
import './App.scss';

function App() {
  return (
    <div className="align-content-centre App">
        <HomePage />
    </div>
  );
}

export default App;
